"use strict";

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_transformer_1 = require("class-transformer");

var class_validator_1 = require("class-validator");

var queryDecorator_1 = require("../queryDecorator");

var account_1 = require("./account");

var address_1 = require("./address");

var pagination_1 = require("./pagination");

var validationSiret_1 = require("../validationSiret");

var architectType_1 = require("../enum/architectType");

var brand_1 = require("./brand");

var auth_1 = require("./auth");

var architectSubscription_1 = require("./architectSubscription");

var ArchitectFilterDTO = function ArchitectFilterDTO() {
  _classCallCheck(this, ArchitectFilterDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectFilterDTO.prototype, "query", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ArchitectFilterDTO.prototype, "brandIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsEnum(architectType_1.ArchitectType, {
  each: true
}), __metadata("design:type", Array)], ArchitectFilterDTO.prototype, "types", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectFilterDTO.prototype, "siret", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectFilterDTO.prototype, "enabled", void 0);

exports.ArchitectFilterDTO = ArchitectFilterDTO;

var ArchitectDTO = function ArchitectDTO() {
  _classCallCheck(this, ArchitectDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ArchitectDTO.prototype, "id", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return account_1.AccountDTO;
}), __metadata("design:type", account_1.AccountDTO)], ArchitectDTO.prototype, "account", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ArchitectDTO.prototype, "companyName", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), validationSiret_1.IsSiret(), __metadata("design:type", String)], ArchitectDTO.prototype, "siret", void 0);

__decorate([class_validator_1.IsEnum(architectType_1.ArchitectType), __metadata("design:type", String)], ArchitectDTO.prototype, "type", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsOptional(), class_transformer_1.Type(function () {
  return architectSubscription_1.ArchitectSubscriptionDTO;
}), class_validator_1.ValidateNested(), __metadata("design:type", architectSubscription_1.ArchitectSubscriptionDTO)], ArchitectDTO.prototype, "subscription", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectDTO.prototype, "downloads", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDateString(), __metadata("design:type", Date)], ArchitectDTO.prototype, "subscriptionStartDate", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDateString(), __metadata("design:type", Date)], ArchitectDTO.prototype, "subscriptionNextPaymentDate", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectDTO.prototype, "subscriptionRemainingDownloads", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectDTO.prototype, "vatCode", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectDTO.prototype, "createdAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectDTO.prototype, "updatedAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ArchitectDTO.prototype, "deletedAt", void 0);

exports.ArchitectDTO = ArchitectDTO;

var ArchitectWithBrandDTO =
/*#__PURE__*/
function (_ArchitectDTO) {
  _inherits(ArchitectWithBrandDTO, _ArchitectDTO);

  function ArchitectWithBrandDTO() {
    _classCallCheck(this, ArchitectWithBrandDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectWithBrandDTO).apply(this, arguments));
  }

  return ArchitectWithBrandDTO;
}(ArchitectDTO);

__decorate([class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return brand_1.BrandLightDTO;
}), __metadata("design:type", Array)], ArchitectWithBrandDTO.prototype, "brands", void 0);

exports.ArchitectWithBrandDTO = ArchitectWithBrandDTO;

var ArchitectCreationDTO =
/*#__PURE__*/
function (_account_1$AccountCre) {
  _inherits(ArchitectCreationDTO, _account_1$AccountCre);

  function ArchitectCreationDTO() {
    _classCallCheck(this, ArchitectCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectCreationDTO).apply(this, arguments));
  }

  return ArchitectCreationDTO;
}(account_1.AccountCreationWithoutTypeDTO);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "companyName", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), validationSiret_1.IsSiret(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "siret", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(architectType_1.ArchitectType), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectCreationDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsEnum(auth_1.Apps), class_validator_1.IsOptional(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "source", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "invitationToken", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectCreationDTO.prototype, "downloads", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDateString(), __metadata("design:type", Date)], ArchitectCreationDTO.prototype, "subscriptionStartDate", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDateString(), __metadata("design:type", Date)], ArchitectCreationDTO.prototype, "subscriptionNextPaymentDate", void 0);

__decorate([class_validator_1.IsOptional(), class_transformer_1.Type(function () {
  return architectSubscription_1.ArchitectSubscriptionDTO;
}), class_validator_1.ValidateNested(), __metadata("design:type", architectSubscription_1.ArchitectSubscriptionDTO)], ArchitectCreationDTO.prototype, "subscription", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectCreationDTO.prototype, "vatCode", void 0);

exports.ArchitectCreationDTO = ArchitectCreationDTO;

var ArchitectInvitationCreationDTO =
/*#__PURE__*/
function (_account_1$AccountCre2) {
  _inherits(ArchitectInvitationCreationDTO, _account_1$AccountCre2);

  function ArchitectInvitationCreationDTO() {
    _classCallCheck(this, ArchitectInvitationCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectInvitationCreationDTO).apply(this, arguments));
  }

  return ArchitectInvitationCreationDTO;
}(account_1.AccountCreationWithoutTypeDTO);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectInvitationCreationDTO.prototype, "address", void 0);

exports.ArchitectInvitationCreationDTO = ArchitectInvitationCreationDTO;

var ArchitectUpdateDTO = function ArchitectUpdateDTO() {
  _classCallCheck(this, ArchitectUpdateDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return account_1.AccountUpdateDTO;
}), __metadata("design:type", account_1.AccountUpdateDTO)], ArchitectUpdateDTO.prototype, "account", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), validationSiret_1.IsSiret(), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "siret", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(architectType_1.ArchitectType), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "companyName", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return address_1.AddressDTO;
}), __metadata("design:type", address_1.AddressDTO)], ArchitectUpdateDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsOptional(), class_transformer_1.Type(function () {
  return architectSubscription_1.ArchitectSubscriptionDTO;
}), class_validator_1.ValidateNested(), __metadata("design:type", architectSubscription_1.ArchitectSubscriptionDTO)], ArchitectUpdateDTO.prototype, "subscription", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDateString(), __metadata("design:type", Date)], ArchitectUpdateDTO.prototype, "subscriptionStartDate", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectUpdateDTO.prototype, "subscriptionRemainingDownloads", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectUpdateDTO.prototype, "downloads", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "vatCode", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(architectSubscription_1.ArchitectSubscriptionType), __metadata("design:type", String)], ArchitectUpdateDTO.prototype, "subscriptionType", void 0);

exports.ArchitectUpdateDTO = ArchitectUpdateDTO;

var ArchitectExtendedDTO =
/*#__PURE__*/
function (_ArchitectDTO2) {
  _inherits(ArchitectExtendedDTO, _ArchitectDTO2);

  function ArchitectExtendedDTO() {
    _classCallCheck(this, ArchitectExtendedDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectExtendedDTO).apply(this, arguments));
  }

  return ArchitectExtendedDTO;
}(ArchitectDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectExtendedDTO.prototype, "countProjects", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectExtendedDTO.prototype, "countDownloadedProducts", void 0);

exports.ArchitectExtendedDTO = ArchitectExtendedDTO;

var ArchitectExtendedBrandDTO =
/*#__PURE__*/
function (_ArchitectExtendedDTO) {
  _inherits(ArchitectExtendedBrandDTO, _ArchitectExtendedDTO);

  function ArchitectExtendedBrandDTO() {
    _classCallCheck(this, ArchitectExtendedBrandDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectExtendedBrandDTO).apply(this, arguments));
  }

  return ArchitectExtendedBrandDTO;
}(ArchitectExtendedDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectExtendedBrandDTO.prototype, "download", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ArchitectExtendedBrandDTO.prototype, "view", void 0);

exports.ArchitectExtendedBrandDTO = ArchitectExtendedBrandDTO;

var ArchitectSuggestionDTO = function ArchitectSuggestionDTO() {
  _classCallCheck(this, ArchitectSuggestionDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ArchitectSuggestionDTO.prototype, "id", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return account_1.AccountSuggestionDTO;
}), __metadata("design:type", account_1.AccountSuggestionDTO)], ArchitectSuggestionDTO.prototype, "account", void 0);

exports.ArchitectSuggestionDTO = ArchitectSuggestionDTO;

var ArchitectPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(ArchitectPaginationResponse, _pagination_1$Paginat);

  function ArchitectPaginationResponse() {
    _classCallCheck(this, ArchitectPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectPaginationResponse).apply(this, arguments));
  }

  return ArchitectPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([pagination_1.PaginationData(ArchitectExtendedDTO), __metadata("design:type", Array)], ArchitectPaginationResponse.prototype, "data", void 0);

exports.ArchitectPaginationResponse = ArchitectPaginationResponse;

var ArchitectBrandPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat2) {
  _inherits(ArchitectBrandPaginationResponse, _pagination_1$Paginat2);

  function ArchitectBrandPaginationResponse() {
    _classCallCheck(this, ArchitectBrandPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArchitectBrandPaginationResponse).apply(this, arguments));
  }

  return ArchitectBrandPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([pagination_1.PaginationData(ArchitectExtendedBrandDTO), __metadata("design:type", Array)], ArchitectBrandPaginationResponse.prototype, "data", void 0);

exports.ArchitectBrandPaginationResponse = ArchitectBrandPaginationResponse;
var ArchitectOrderEnum;

(function (ArchitectOrderEnum) {
  ArchitectOrderEnum["companyName"] = "companyName";
})(ArchitectOrderEnum || (ArchitectOrderEnum = {}));

var ArchitectBrandStatOrderEnum;

(function (ArchitectBrandStatOrderEnum) {
  ArchitectBrandStatOrderEnum["download"] = "download";
  ArchitectBrandStatOrderEnum["view"] = "view";
})(ArchitectBrandStatOrderEnum || (ArchitectBrandStatOrderEnum = {}));

exports.ArchitectAndAccountOrderEnum = Object.assign({}, ArchitectOrderEnum, account_1.AccountOrderEnum);
exports.ArchitectAndAccountAndBrandStatOrderEnum = Object.assign({}, exports.ArchitectAndAccountOrderEnum, ArchitectBrandStatOrderEnum);